<template>
	<div class="content">
		<headerTop :value="2"></headerTop>
		<div class="search page-content flexleft">
			<div class="img" @click="searchL">
				<img src="../../assets/image/searchs.png" alt="">
			</div>
			<div class="ipt">
				<input type="text" placeholder="请输入搜索内容" v-model="keywords" @keyup.enter="searchL">
			</div>
		</div>
		<div class="tabs page-content flexleft">
			<div class="child" :class="index == current?'active':'' " v-for="(item,index) in tabList" :key="index"
				@click="change(index)">{{item.name}}</div>
		</div>
		<div class="empty page-content" v-if="total == 0">
			<img src="../../assets/image/empty.png" alt="">
			<div class="txt">暂无数据</div>
		</div>
		<div class="center" v-else>
			<div class="botList page-content" v-if="current == 2">
				<div class="botchild flexleft" v-for="(items,indexs) in list" :key="indexs"
					@click="todetails(items.url)">
					<div class="parentLittle">
						<div class="little"></div>
					</div>
					<div class="bottitle flexbetween">
						<div class="titles">{{items.title}}</div>
						<div class="time">{{items.updatetime}}</div>
					</div>
				</div>
			</div>
			<!-- 学习课程 -->
			<div class="videoLists page-content flexleft" v-if="current == 5">
				<div class="child" v-for="(item,index) in list" :key="index" @click="todetail(item.id)">
					<div class="time">{{item.createtime}}</div>
					<div class="topImg">
						<img :src="$index.addurl(item.thum)" alt="">
					</div>
					<div class="bottomTxt">
						<div class="title">{{ item.title }}</div>
						<div class="info flexleft">
							<div class="name">{{ item.info }}</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 查项目库 -->
			<div class="shenbaoright page-content" v-if="current == 4 && total != 0">
				<div class="box5 box2_cc">
					<div class="box5_text1 text-cut">企业名称</div>
					<div class="box5_text2 text-cut">基本情况</div>
					<div class="box5_text4 text-cut">行业</div>
					<div class="box5_text2 text-cut">投资亮点</div>
					<div class="box5_text4 text-cut">轮次</div>
					<div class="box5_text4 text-cut">融资金额</div>
					<div class="box5_text5 text-cut">操作</div>
				</div>
				<div style="min-height: 550px;">
					<div v-for="(item, index) in list" :key="index" class="box5">
						<div class="box5_text1">{{ item.name }}</div>
						<div class="box5_text2">{{ item.basic_info }}</div>
						<div class="box5_text4">{{ item.trade.name }}</div>
						<div class="box5_text2">{{ item.tzld }}</div>
						<div class="box5_text4">{{ item.round }}</div>
						<div class="box5_text4">{{ item.financing }}</div>
						<div class="box5_text5 text-cut cpoint" @click="todetail(item.id)">
							<div class="box2_nei">查看详情</div>
						</div>
					</div>
				</div>
			</div>
			<div class="shenbaoright page-contents" style="width:100%" v-if="current == 4 && total == 0">
				<div class="nodata flex justify-center align-center flex-direction">
					<div class="" style="font-size: 18px">暂无数据</div>
				</div>
			</div>
			<!-- 服务案例 -->
			<div class="fwal page-content" v-if=" current == 0 || current == 1 ">
				<div class="anliList flexleft">
					<div class="alchild" v-for="(item,index) in list" :key="index" @click="toDetail(item.id)">
						<div class="img">
							<img :src="$index.addurl(item.image)" alt="">
						</div>
						<div class="title">{{item.title}}</div>
						<div class="time">{{item.createtime}}</div>
					</div>
				</div>
			</div>
			<!-- 参加活动 -->
			<div class="videoList page-content flexleft" v-if="current == 3">
				<div class="child flexbetween" v-for="(item,index) in list" :key="index">
					<div class="left">
						<div class="endetime flexleft">
							<div class="colorLv" v-if="item.endtime<=timestamp"></div>
							<div class="colorRed" v-if="item.endtime>timestamp"></div>
							<div class="txt">
								{{item.endtime * 1000 > timestamp && timestamp > item.starttime * 1000 ? '正在进行': timestamp > item.endtime*1000 ? '已结束' :'未开始'}}&nbsp;{{ item.start }}-{{ item.end }}
							</div>
						</div>
						<img :src="$index.addurl(item.thum)" alt="">
					</div>
					<div class="right">
						<div class="right_title">{{ item.title }}</div>
						<div class="times flexleft">
							<div class="time">{{ item.start }} --- {{ item.end }}</div>
							<div class="type">{{ item.type == 1?'线上' : item.type == 2 ? '线下' : '线上+线下' }}</div>
						</div>
						<div class="time">{{item.end}}</div>
						<div class="contentss">{{item.info}}</div>
						<div class="address flexleft">
							<div class="addImg">
								<img src="../../assets/image/dingwei.png" alt="" v-if="item.type == 2">
								<img src="../../assets/image/diannao.png" alt="" v-if="item.type == 1">
							</div>
							<div class="txt flexleft">
								<div class="addressTxt" v-if="item.type == 2">地址：{{ item.offline_address }}</div>
							</div>
						</div>
						<div class="flexright">
							<div class="ljmore" @click.stop="todetail(item.id)">了解更多</div>
						</div>
					</div>
				</div>
			</div>
			<div class="page">
				<el-pagination :hide-on-single-page="value" :current-page="currentPage" :page-size="20"
					@current-change="addPage" layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default {
		components: {
			headerTop
		},
		data() {
			return {
				value: true, //分页只有一页时隐藏分页
				currentPage: 1, //分页当前页数
				total: 0,
				pageCount: 0,
				list: [],
				timestamp: '', //当前时间时间戳
				tabList: [{
					name: '服务案例',
				}, {
					name: '品牌服务',
				}, {
					name: '广场动态',
				}, {
					name: '参加活动',
				}, {
					name: '查项目库',
				}, {
					name: '学习课程',
				}, ],
				animation: '',
				current: 0,
				keywords: '',
			}
		},
		created() {
			this.animation = 'translate .8s linear forwards';
			this.timestamp = new Date().getTime();
			this.getdata();
		},
		methods: {
			searchL() {
				let _this = this;
				_this.currentPage = 1;
				_this.total = 0;
				_this.list = [];
				if (_this.current == 0) _this.getdata();
				else if (_this.current == 1) _this.getdataOne();
				else if (_this.current == 2) _this.getdataTwo();
				else if (_this.current == 3) _this.getdataThree();
				else if (_this.current == 4) _this.getdataFour();
				else if (_this.current == 5) _this.getdataFive();
			},
			todetail(id) {
				let name = this.current == 4 ? 'searchXmdetail' : 'joinActivitydetail';
				const {
					href
				} = this.$router.resolve({
					name: name,
					query: {
						id: id,
					}
				});
				window.open(href, '_blank');
			},
			todetails(url) {
				window.open(url, '_blank');
			},
			toDetail(id) {
				let _this = this;
				let name = _this.current == 0 ? 'fwAldetail' : 'hdAldetail';
				_this.$router.push({
					name: name,
					params: {
						id: id
					}
				});
			},
			date(timestamp) {
				var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
				var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
				var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
				var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
				return Y + M + D;
			},
			addPage(e) {
				let _this = this;
				_this.currentPage = e;
				if (_this.current == 0) _this.getdata();
				else if (_this.current == 1) _this.getdataOne();
				else if (_this.current == 2) _this.getdataTwo();
				else if (_this.current == 3) _this.getdataThree();
				else if (_this.current == 4) _this.getdataFour();
				else if (_this.current == 5) _this.getdataFive();
			},
			change(index) {
				let _this = this;
				_this.currentPage = 1;
				_this.list = [];
				_this.current = index;
				if (_this.current == 0) _this.getdata();
				else if (_this.current == 1) _this.getdataOne();
				else if (_this.current == 2) _this.getdataTwo();
				else if (_this.current == 3) _this.getdataThree();
				else if (_this.current == 4) _this.getdataFour();
				else if (_this.current == 5) _this.getdataFive();
			},
			getdataFive() {
				let _this = this;
				_this.list = [];
				_this.$api.user.getLessonList({
					page: _this.currentPage,
					keywords: _this.keywords,
				}).then(res => {
					if (res.code == 1) {
						res.data.list.data.forEach(item => {
							item.createtime = _this.timestampToTime(item.createtime);
						})
						_this.list = res.data.list.data;
						_this.currentPage = res.data.list.current_page;
						_this.total = res.data.list.total;
					}
				})
			},
			getdataFour() {
				let _this = this;
				_this.$api.user.getCxmkList({
					page: _this.currentPage,
					keywords: _this.keywords,
				}).then(res => {
					if (res.code == 1) {
						_this.list = res.data.list.data;
						_this.total = res.data.list.total;
					}
				})
			},
			getdataThree() {
				let _this = this;
				_this.$api.user.getCjhdList({
					page: _this.currentPage,
					keywords: _this.keywords,
				}).then(res => {
					if (res.code == 1) {
						res.data.list.data.forEach(item => {
							_this.$set(item, 'end', '');
							_this.$set(item, 'start', '');
							item.end = _this.date(item.endtime * 1000);
							item.start = _this.date(item.starttime * 1000);
						})
						_this.list = res.data.list.data;
						_this.total = res.data.list.total;
						_this.currentPage = res.data.list.current_page;
					}
				})
			},
			getdataTwo() {
				let _this = this;
				_this.$api.user.getTrendsSquare({
					page: _this.currentPage,
					keywords: _this.keywords,
				}).then(res => {
					if (res.code == 1) {
						res.data.list.data.forEach(item => {
							item.createtime = _this.date(item.createtime);
						})
						_this.list = res.data.list.data;
						_this.currentPage = res.data.list.current_page;
						_this.total = res.data.list.total;
					}
				})
			},
			getdataOne() {
				let _this = this;
				_this.$api.user.activityCasesList({
					page: _this.currentPage,
					keywords: _this.keywords,
				}).then(res => {
					if (res.code == 1) {
						_this.img = res.data.background_img;
						res.data.list.data.forEach(item => {
							item.createtime = _this.date(item.createtime * 1000);
						})
						_this.total = res.data.list.total;
						_this.pageCount = res.data.list.last_page;
						_this.list = res.data.list.data;
					}
				})
			},
			getdata() {
				let _this = this;
				_this.$api.user.serviceCasesList({
					page: _this.currentPage,
					keywords: _this.keywords,
				}).then(res => {
					if (res.code == 1) {
						res.data.list.data.forEach(item => {
							item.createtime = _this.date(item.createtime * 1000);
						})
						_this.total = res.data.list.total;
						_this.pageCount = res.data.list.last_page;
						_this.list = res.data.list.data;
					}
				})

			},
		},

	}
</script>
<style scoped lang="scss">
	.empty {
		margin: 50px auto 0;

		img {
			display: block;
			margin: auto;
			width: 160px;
			height: 180px;
		}

		.txt {
			text-align: center;
			font-size: 22px;
			color: #666;
		}
	}

	.weizhi {
		width: 1350px;
		overflow: hidden;
		margin: 0 auto;
	}

	.shenbaoright {
		/* width: 1200px; */
		margin: 0 auto;
		overflow: hidden;
	}

	.shenbaoright ul {
		border: 1px solid #eee;
		padding: 0 10px;
		min-height: 742px;
	}

	.shenbaoright li {
		border-bottom: 1px dashed #eee;
		line-height: 36px;
		position: relative;
	}

	.shenbaoright li span {
		position: absolute;
		top: 0;
		right: 0;
	}

	.sr_b {
		position: relative;
		margin-bottom: 30px;
	}

	.sr_btn {
		border: 1px solid #eee;
		border-radius: 5px;
		width: 175px;
		text-align: center;
		height: 32px;
		line-height: 32px;
		font-size: 14px;
		margin-top: 30px;
	}

	.fan {
		display: flex;
		position: absolute;
		right: 15px;
		top: 0;
		height: 32px;
		align-items: center;
	}

	.fan em {
		border-radius: 3px;
		margin: 0;
		border: 1px solid #eee;
		height: 18px;
		width: 32px;
		text-align: center;
		line-height: 18px;
		margin: 0 5px;
	}

	.fan p {
		margin: 0;
		line-height: 18px;
	}

	.fan span {
		display: block;
		width: 18px;
		height: 18px;
		border: 1px solid #eee;
		text-align: center;
		line-height: 18px;
		border-radius: 3px;
	}

	.danhang {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.nodata {
		border: 1px solid #eee;
		padding: 10px;
		min-height: 742px;
	}

	.box2_until_center {
		display: flex;
	}

	.box2_until_left {
		font-size: 14px;
		color: #959595;
		width: 55px;
		line-height: 28px;
	}

	.box2_until_right {
		height: 28px;
		font-size: 14px;
		line-height: 28px;
		padding: 0 8px;
		color: #4e4e4e;
		margin-bottom: 10px;
		margin: 0 10px;
	}

	.bgc {
		background-color: #0070c0;
		color: #fff;
	}

	.borbot {
		border-bottom: 1px solid #eee;
	}

	.box2_cent {
		display: flex;
		width: 93%;
		flex-wrap: wrap;
		min-height: 38px;
	}

	.sty {
		color: #ffffff;
		background: #0070c0;
	}


	.oneleft {
		width: 99px;
		height: 99px;
	}

	.oneleft img {
		width: 99px;
		height: 99px;
		border-radius: 10px;
	}

	.oneright {
		margin-top: 10px;
		width: 77%;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		flex-direction: column;
	}

	.oneright p {
		font-size: 14px;
		color: #292a2d;
		font-weight: 400;
		padding-bottom: 2px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 214px;
	}

	.oneright span {
		display: inline-block;
		padding: 2px 8px;
		font-size: 12px;
		color: #fff;
		font-weight: 400;
		background: #36a6f7;
		border-radius: 2px;
	}

	.likeone {
		height: auto;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-bottom: 25px;
	}

	.likeone:last-child {
		margin-bottom: 0px;
	}

	.box1_header {
		display: flex;
		/* height: 55px; */
		align-items: center;
		/* border-bottom: 1px solid #eee; */
	}

	.box1_header_text {
		font-size: 20px;
		color: #111111;
		font-weight: 600;
		margin-left: 10px;
	}

	.box1_header_shu {
		width: 4px;
		height: 21px;
		background-color: #0070c0;
	}

	.cright {
		position: sticky;
		/* top: 166px; */
		top: 20px;
	}



	.box5 {
		width: 100%;
		display: flex;
		min-height: 50px;
		border-bottom: 1px solid #f1f1f1;
	}

	.box5_text1 {
		width: 20%;
		display: flex;
		align-items: center;
		border-right: 1px solid #f1f1f1;
		border-left: 1px solid #f1f1f1;
		padding: 5px;
		justify-content: center;
	}

	.box5_text2 {
		width: 27%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f1f1;
		padding: 5px;
	}

	.box5_text4 {
		width: 8%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f1f1;
		padding: 5px;
	}

	.box5_text5 {
		width: 10%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f1f1;
		padding: 5px;
	}

	.box5_text3 {
		width: 12%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f1f1;
		padding: 5px;
	}

	.sty {
		color: #ffffff;
		background: #0070c0;
	}

	.box2_cc {
		color: #ffffff;
		background-color: #0070c0;
	}

	.box2_nei {
		/* width: 95px; */
		height: 30px;
		padding: 0 15px;
		/* background-color: #ff6c00; */
		background-color: #0160a3;
		color: #ffffff;
		border-radius: 7px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
<style scoped lang="scss">
	.botList {
		margin: 20px auto;

		.botchild {
			.parentLittle {
				padding: 15px;
				border: 1px solid #eee;

				.little {
					width: 10px;
					height: 10px;
					border-radius: 50%;
					background-color: #1452DC;
				}
			}

			.bottitle {
				flex-grow: 1;
				border: 1px solid #eee;
				font-size: 14px;
				color: #333;
				line-height: 40px;
				padding: 0 10px;

				.titles {
					flex-grow: 1;
					display: -webkit-box;
					overflow: hidden;
					/*! autoprefixer: off; */
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
				}

				.time {
					min-width: 100px;
					text-align: right;
				}
			}
		}

		.botchild:hover {
			animation: opacitys .2s linear forwards;
			cursor: pointer;

			.parentLittle {
				border: 1px solid #1452DC;

				.little {
					background-color: #fff;
				}
			}

			.bottitle {
				color: #fff;
				border: 1px solid #1452DC;
			}
		}
	}

	.page {
		margin: 50px auto;
		display: flex;
		justify-content: center;
	}

	.videoLists {
		flex-wrap: wrap;
		margin: auto;

		.child {
			margin: 10px;
			width: 23%;
			position: relative;
			cursor: pointer;

			.time {
				position: absolute;
				top: 6px;
				left: 6px;
				background-color: rgba(0, 0, 0, 0.5);
				padding: 6px;
				color: #fff;
				border-radius: 6px;
			}

			.topImg {
				height: 200px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.bottomTxt {
				padding: 10px;

				.title {
					font-size: 16px;
					color: #333;
					display: -webkit-box;
					overflow: hidden;
					/*! autoprefixer: off; */
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
				}

				.info {
					color: lightgray;
					font-size: 14px;
					padding: 6px 0;
					line-height: 28px;
					display: -webkit-box;
					overflow: hidden;
					/*! autoprefixer: off; */
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;

					.tag {
						margin-left: 5px;
					}
				}
			}
		}
	}

	.videoList {
		flex-wrap: wrap;
		margin: auto;

		.child {
			width: 100%;
			border-top: 20px solid #F3F4F8;
			padding: 30px;

			.left {
				width: 600px;
				height: 320px;
				margin-right: 50px;
				position: relative;

				img {
					object-fit: fill;
					width: 600px;
					height: 320px;
				}

				.endetime {
					position: absolute;
					top: 10px;
					left: 10px;
					background-color: rgba(0, 0, 0, 0.5);
					padding: 10px;
					border-radius: 4px;

					.colorLv {
						width: 10px;
						height: 10px;
						border-radius: 50%;
						background-color: #04FD8A;
					}

					.colorRed {
						width: 12px;
						height: 12px;
						border-radius: 50%;
						background-color: #ff0000;
					}

					.txt {
						margin-left: 6px;
						font-size: 14px;
					}
				}
			}

			.right {
				align-self: flex-start;
				flex-grow: 1;
				position: relative;

				.times {
					.type {
						margin-left: 10px;
						font-size: 18px;
					}

					.time {
						color: #333;
						font-size: 18px;
						margin: 10px 0;
					}
				}

				.right_title {
					font-weight: bold;
					font-size: 24px;
					color: #333;
				}

				.contentss {
					color: #333;
					font-size: 16px;
					margin: 20px 0 10px;
					min-height: 100px;
					display: -webkit-box;
					overflow: hidden;
					/*! autoprefixer: off; */
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 4;
				}

				.address {
					margin-bottom: 10px;

					.addImg {
						width: 24px;
						height: 24px;
						margin-right: 10px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.txt {
						color: #ABAAB5;
						font-size: 18px;
					}
				}

				.ljmore {
					width: 120px;
					text-align: center;
					padding: 10px 0;
					font-size: 16px;
					color: #fff;
					background-color: #1452DC;
					cursor: pointer;
				}
			}
		}
	}

	.fwal {
		margin: auto;

		.anliList {
			flex-wrap: wrap;

			.alchild {
				width: 23%;
				margin: 0 14px 30px;
				cursor: pointer;

				.img {
					width: 100%;
					height: 180px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.title {
					font-size: 18px;
					color: #333;
					font-weight: 600;
					margin: 10px 0;
				}

				.time {
					font-size: 12px;
					color: #aaa;
				}
			}
		}
	}

	.tabs {
		padding: 30px 20px;
		margin: 0 auto;

		.child {
			border: 1px solid #666;
			border-radius: 20px;
			padding: 6px 16px;
			margin: 0 20px;
			font-size: 16px;
			color: #666;
			cursor: pointer;
			transition: linear .3s;
		}

		.active {
			background-color: #0070C0;
			color: #fff;
			cursor: pointer;
			border: 1px solid #0070C0;
			border-radius: 20px;
			padding: 6px 16px;
			margin: 0 20px;
			font-size: 16px;
		}

		.child:first-child {
			margin: 0 20px 0 0;
		}
	}

	.search {
		// width: 50%;
		margin: 140px auto 30px;
		border: 1px solid #eee;
		border-radius: 40px;
		padding: 10px 20px;

		.img {
			width: 30px;
			height: 30px;
			cursor: pointer;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.ipt {
			flex-grow: 1;

			input {
				width: 100%;
				text-align: center;
				font-size: 24px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// search.vue?2f3f8f84